import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import filtersStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/filtersStyle.jsx";
import classNames from 'classnames';
import nouislider from 'nouislider';
import TranslationService from '../../../services/translation/TransationService';

class SectionWork extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: [1, 9, 27],
      priceRange: [0, 5]
    };
  }
  componentDidMount() {
    let slider = this.refs.slider1;
    let priceLow = this.refs.priceLow;
    let priceHigh = this.refs.priceHigh;
    nouislider
      .create(slider, {
        start: this.state.priceRange,
        connect: true,
        range: { min: 1, max: 5 },
        step: 1
      })
      .on("update", (values, handle) => {
        let currencyLow = priceLow.dataset.currency;
        let currencyHigh = priceHigh.dataset.currency;
        priceLow.innerHTML = currencyLow + Math.round(values[0]);
        priceHigh.innerHTML = currencyHigh + Math.round(values[1]);
        this.props.setValue('minScore')(currencyLow + Math.round(values[0]));
        this.props.setValue('maxScore')(currencyHigh + Math.round(values[1]));
      });
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section} id="facilities">
        <GridContainer justify="center">
          <GridItem cs={12} sm={8} md={8}>
            <h2 className={classes.title}>{ TranslationService.get('SEARCH.TITLE') }</h2>
            <h4 className={classes.description}>
              { TranslationService.get('SEARCH.CONTENT') }
            </h4>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText={ TranslationService.get('SEARCH.FILTERS.NAME') }
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{onChange: (e) => this.props.setValue('name')(e.target.value)}}
                  />
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText={ TranslationService.get('SEARCH.FILTERS.ADDRESS') }
                    id="address"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{onChange: (e) => this.props.setValue('address')(e.target.value)}}
                  />
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <br />
                  <p
                    className={classNames(
                      classes.pullLeft,
                      classes.priceSlider
                    )}
                  >
                    { TranslationService.get('SEARCH.FILTERS.SCORE') }
                  </p>
                  <div ref="slider1" className="slider-primary" />
                  <span
                    ref="priceLow"
                    data-currency=""
                    className={classNames(
                      classes.pullLeft,
                      classes.priceSlider
                    )}
                  >
                    0
                  </span>
                  <span
                    ref="priceHigh"
                    data-currency=""
                    className={classNames(
                      classes.pullRight,
                      classes.priceSlider
                    )}
                  >
                    0
                  </span>
                  <br />
                </GridItem>
              </GridContainer>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(filtersStyle)(SectionWork);



// WEBPACK FOOTER //
// ./src/views/QxQPublicPage/Sections/SectionFilters.jsx